import React, { useEffect } from 'react';

import Description from "../../components/description/Description"
import Presentation from "../../components/presentation/Presentation"
import Information from "../../components/information/Information"


const Home = () => {
    useEffect(() => {
        document.title = 'Net Viet | Restaurant Vietnamien | Restaurant Asiatique | Restaurant Rueil-Malmaison';
    });

    return (
        <div id="Home">
            <Presentation />
            <Description />
            <Information />
        </div>
    );
};

export default Home;